export function hasDifferentField<T extends object>(obj1: T, obj2: T): boolean {
    for (let key in obj1) {
        if (obj1.hasOwnProperty(key)) {
            const val1: T[Extract<keyof T, string>] = obj1[key];
            const val2: T[Extract<keyof T, string>] = obj2[key];

            if (typeof val1 === 'object' && val1 !== null && typeof val2 === 'object' && val2 !== null) {
                if (hasDifferentField(val1, val2)) {
                    return true;
                }
            } else if (val1 !== val2) {
                return true;
            }
        }
    }
    return false;
}
